import { IAidasProject } from 'app/shared/model/ainnotateservice/aidas-project.model';
import { IAidasProperties } from 'app/shared/model/ainnotateservice/aidas-properties.model';

export interface IAidasProjectProperty {
  id?: number;
  value?: string | null;
  aidasProject?: IAidasProject;
  aidasProperties?: IAidasProperties | null;
}

export const defaultValue: Readonly<IAidasProjectProperty> = {};
